<script setup lang="ts">
import { useRouter } from 'vue-router';

import { TButton } from '@/components/ui/button';

const router = useRouter();

const { disabled } = defineProps<{
  disabled?: boolean;
}>();

const handleClick = () => {
  return router.push('/deposit/EUA_DAILY');
};
</script>

<template>
  <TButton variant="secondary" size="fluid-default" :disabled="disabled" @click="handleClick">
    {{ $t('layout.navBar.userDropdown.deposit') }}
  </TButton>
</template>
